import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";

function Singleproject(props) {
  const gradientStyle = {
    background: "linear-gradient(90deg, #f3faff 70%, rgb(255, 255, 255) 70%)",
  };
  const ColorStyle = {
    color: "#54a4c9",
  };
  const textAndBackgroundColor = {
    backgroundColor: "#54a4c9",
  };
  return (
    <div className="singleproject p-100" style={gradientStyle}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="img_logo">
              <StaticImage
                src="../../../images/location_new/singlecase/Onsite-Logo.webp"
                alt="LogoNext"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={220}
                height={80}
              />
            </div>
            <div className="example" data-text="Feature">
              <h2 style={ColorStyle}>
                Onsite Social: Bringing Real-World Connections to the Digital
                Realm
              </h2>
            </div>
            <p style={ColorStyle}>
              OnSite Social, a groundbreaking mobile app crafted by TekRevol,
              acts as a bridge between the physical and digital realms. It
              connects users based on their real-time locations, fostering
              meaningful connections.
            </p>
            <Link
              to={`/case-studies/onsite`}
              className="case_btn"
              aria-label="TekRevol Contact"
              style={textAndBackgroundColor}
            >
              View Case Study {Case_Arrow}
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="technology_list">
              <div className="tech_name">iOS App</div>
              <div className="tech_name">Android App</div>
              <div className="tech_name">UI UX Design</div>
            </div>
            <div className="mx-img">
              <StaticImage
                src="../../../images/location_new/singlecase/onsite.webp"
                alt="android-app-development-services-company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={909}
                height={575}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Singleproject;
